const COOKIES = {
  browserCookieId: 'BrowserCookieId',
  city: 'CVCurrentCity',
  featureBranchEnabled: 'carvana-merch-serenity-ui',
  featureBranchName: 'carvana-merch-serenity-ui-feature-name',
  hasAppliedTrade: 'merch-tradein-applied',
  dismissedNewPriceBanner: 'merch-dismissed-new-price-banner',
  idToken: 'CVIdToken',
  partnerId: 'CVActivePartnerId',
  session: 'mdt-session-id',
  state: 'CVCurrentState',
  verboseLogging: 'merch-verbose-logging',
  zip: 'CVCurrentZip'
};

export default COOKIES;
